import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { type Appointment } from '../../../data-access/appointments';

const appointmentsSchema = {
  version: 0,
  primaryKey: 'appointmentId',
  type: 'object',
  properties: {
    appointmentId: { type: 'string', maxLength: 36 },
    appointment: { type: 'object' },
    customer: { type: 'object' },
    job: { type: 'object' },
    location: { type: 'object' },
    memberships: { type: 'array' },
    activities: { type: 'array' },
  },
  required: [
    'appointmentId',
    'appointment',
    'customer',
    'job',
    'location',
    'memberships',
    'activities',
  ],
} as const;

export const appointmentsCollections: Record<
  'appointments',
  RxCollectionCreator
> = {
  appointments: {
    autoMigrate: false,
    schema: appointmentsSchema,
  },
};

export type AppointmentCollections = {
  appointments: RxCollection<Appointment>;
};
